// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fca3be8d","455":"4b29b9a6","977":"0f5bc390"}[chunkId] + ".chunk.js";
};